<div class="ps">
  <div class="muted small">{{ 'privacySettings.intro' | translate }}</div>

  <div class="muted small" *ngIf="loading">{{ 'privacySettings.loading' | translate }}</div>
  <div class="ps-error" *ngIf="loadError" role="alert">{{ 'privacySettings.loadError' | translate }}</div>

  <ng-container *ngIf="!loading && !loadError">
    <div class="ps-row" *ngFor="let row of rows">
      <div class="ps-text">
        <div class="ps-label">{{ 'privacySettings.item.' + row.i18n | translate }}</div>
        <div class="muted small">{{ 'privacySettings.item.' + row.i18n + 'Desc' | translate }}</div>
        <div class="ps-status" [class.on]="isOn(row.key)">
          {{ (isOn(row.key) ? 'privacySettings.statusOn' : 'privacySettings.statusOff') | translate }}
        </div>
      </div>
      <button type="button" class="ps-btn" [class.withdraw]="isOn(row.key)"
        [disabled]="busyKey !== null" (click)="toggle(row)">
        {{ (busyKey === row.key ? 'privacySettings.saving' : (isOn(row.key) ? 'privacySettings.turnOff' : 'privacySettings.turnOn')) | translate }}
      </button>
    </div>
    <div class="ps-error" *ngIf="saveError" role="alert">{{ saveError }}</div>

    <div class="ps-blocked" *ngIf="blocked" role="status">
      <p>{{ 'privacySettings.blockedNotice' | translate }}</p>
      <button type="button" class="btn-link" (click)="requestDeletion.emit()">
        {{ 'privacySettings.deleteOffer' | translate }}
      </button>
    </div>
  </ng-container>

  <div class="ps-actions">
    <button type="button" class="btn-link" *ngIf="isWeb" (click)="openCookieSettings()">
      {{ 'privacySettings.cookieSettings' | translate }}
    </button>
    <button type="button" class="ps-btn" [disabled]="exportBusy" (click)="downloadMyData()">
      {{ (exportBusy ? 'privacySettings.exportBusy' : 'privacySettings.export') | translate }}
    </button>
    <div class="muted small">{{ 'privacySettings.exportHelp' | translate }}</div>
    <div class="ps-error" *ngIf="exportError" role="alert">{{ exportError }}</div>
  </div>
</div>
